import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';

// Api
import {list as listDocumentsApi} from '@drivesally/sally-fn/lib/document/api';

// Components
import GasPictureRow from '../GasPictureRow/GasPictureRow';
import Divider from './components/Divider';
import Rows from './components/Rows';

// Constants
import CUSTOM_PICTURE_SECTIONS from '../../constants/customPictureSections.const.gas';

// Lib
import getSectionPictureDocuments from '../../lib/getSectionPictureDocuments.lib.gas';

class GasPictures extends Component {
  static propTypes = {
    sections: PropTypes.array,
    gas: PropTypes.object,
  };

  static defaultProps = {
    sections: [],
  };

  state = {
    customDocuments: {},
  };

  componentDidMount() {
    this.fetchCustomSections();
  }

  fetchCustomSections = async () => {
    const {sections, gas} = this.props;
    const keys = sections
      .map(({key}) => key)
      .filter((key) => !!CUSTOM_PICTURE_SECTIONS[key]);

    await Promise.all(
      keys.map(async (key) => {
        try {
          const {results} = await listDocumentsApi({
            gas: gas.id,
            type: CUSTOM_PICTURE_SECTIONS[key],
          });
          const documents = [...results].map((doc) => ({
            id: doc.id,
            src: doc.document_file,
            label: null,
          }));
          this.setState((state) => ({
            customDocuments: {...state.customDocuments, [key]: documents},
          }));
        } catch (error) {
          this.setState((state) => ({
            customDocuments: {...state.customDocuments, [key]: []},
          }));
        }
      })
    );
  };

  rows = () => {
    const {sections, gas} = this.props;
    const {customDocuments} = this.state;

    // Only ever shown for sections that actually have a photo to display -
    // an overridden-but-photo-less section already shows that override note
    // in the main grid (see hasSectionContent), so repeating an empty box
    // here would just be a duplicate.
    return sections
      .map((section) => {
        const documents = CUSTOM_PICTURE_SECTIONS[section.key]
          ? customDocuments[section.key] || []
          : getSectionPictureDocuments(section, gas);

        if (!documents.length) return null;
        return {section, documents};
      })
      .filter(Boolean);
  };

  render() {
    const {gas} = this.props;
    const rows = this.rows();
    if (!rows.length) return null;

    return (
      <Fragment>
        <Divider>Pictures</Divider>
        <Rows>
          {rows.map(({section, documents}) => (
            <GasPictureRow
              key={section.key}
              section={section}
              gas={gas}
              documents={documents}
            />
          ))}
        </Rows>
      </Fragment>
    );
  }
}

export default GasPictures;
